<div class="row" style="padding: 5px">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<div *ngIf="loading == true" class="SpinnerDiv">
					<p-progressSpinner></p-progressSpinner>
				</div>

				<!--Info Grid-->
				<div *ngIf="loading == false" class="MainGrid">
					<!--Left Col-->
					<div class="Grid2Col">
						<!--General Info-->
						<label>Name:</label>
						<p>{{ Name }}</p>

						<label>Student ID:</label>
						<p>{{ StudentID }}</p>

						<label *ngIf="IsSU() == true">Person ID:</label>
						<p *ngIf="IsSU() == true">{{ PersonID }}</p>

						<label>Gender:</label>
						<p>{{ Gender }}</p>

						<label>Birth Date:</label>
						<p>{{ BirthDate }}</p>

						<label>Ethnicity:</label>
						<p>{{ Ethnicity }}</p>

						<label>Race:</label>
						<p>{{ Race }}</p>

						<label>Home Language:</label>
						<p>{{ HomeLanguage }}</p>

						<!--Contact/Address Ifno-->
						<label>Address:</label>
						<p>{{ Address }}</p>

						<label>City, State, Zip:</label>
						<p>{{ CityStateZip }}</p>

						<label>Home Phone:</label>
						<p>{{ HomePhone }}</p>

						<label>Cell Phone:</label>
						<p>{{ Cellphone }}</p>

						<label>E-mail:</label>
						<p>{{ EMail }}</p>

						<label>Bus Number:</label>
						<p>{{ BusNumber }}</p>

						<label>{{ SSNLabel }}:</label>
						<p>{{ SSN }}</p>

						<!-- <label>MTA RIDER INFO:</label>
                        <div></div> -->

						<label *ngIf="EnableMTA == true || EnablePARider == true">{{ PublicTransitLabel }} Rider:</label>
						<div *ngIf="EnableMTA == true || EnablePARider == true" class="MultiOptions">
							<p style="margin-left: 0px; margin-right: 10px" *ngIf="EnableMTA == true || EnablePARider == true">
								{{ IsMTARider == true ? "Yes" : "No" }}
							</p>

							<label class="FlexItem" *ngIf="EnableMTAOverrideSchool == true">Override</label>
							<input
								*ngIf="EnableMTAOverrideSchool == true"
								class="form-control CHKWidth FlexItem"
								type="checkbox"
								(click)="onOverrideMTAClick($event)"
								[(ngModel)]="MTAOverride"
								[disabled]="loading == true || isProcessing == true"
							/>
						</div>

						<label *ngIf="MTAOverride == true && OverrideReason">Override Reason:</label>
						<p *ngIf="MTAOverride == true && OverrideReason">
							{{ OverrideReason }}
						</p>

						<ng-container *ngFor="let o of lstExtendedInfoLCol">
							<label class="ExtendedHeader">{{ o.ColHeading }}:</label>
							<p class="ExtendedValue">{{ o.ColValue }}</p>
						</ng-container>
					</div>

					<!--Right Col-->
					<div class="Grid2Col">
						<!--School Info-->
						<label>Cohort:</label>
						<p>{{ Cohort }}</p>

						<label>Grade:</label>
						<p>{{ Grade }}</p>

						<label>Academy:</label>
						<p>{{ Academy }}</p>

						<label>Homeroom:</label>
						<p>{{ Homeroom }}</p>

						<label>Advisor:</label>
						<p>{{ Advisor }}</p>

						<!--Fines-->
						<label>Fines Owed:</label>
						<p>{{ FinesOwed }}</p>

						<label>Student Owes for Meals:</label>
						<p>{{ MealsOwed }}</p>

						<label>Meal Subsidy Type:</label>
						<p>{{ MealSubsidyType }}</p>

						<!--Disability Info-->
						<label>Intensity Level:</label>
						<p>{{ IntensityLevel }}</p>

						<label>Section 504:</label>
						<p>{{ Section504 }}</p>

						<label>IEP:</label>
						<p>{{ IEP }}</p>

						<!--Enroll Info-->
						<label>CAASS Enrollment Date:</label>
						<p>{{ EnrollmentDate }}</p>

						<label>CAASS Withdrawal Date:</label>
						<p>{{ WithdrawalDate }}</p>

						<ng-container *ngFor="let o of lstExtendedInfoRCol">
							<label class="ExtendedHeader">{{ o.ColHeading }}:</label>
							<p class="ExtendedValue">{{ o.ColValue }}</p>
						</ng-container>
					</div>
				</div>

				<div class="Buttons">
					<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onPrint()">Print</button>
				</div>

				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>

				<div class="TopMargin">
					<div name="isProcessing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
				</div>

				<div *ngIf="loading == true" class="SpinnerDiv">
					<p-progressSpinner></p-progressSpinner>
				</div>

				<!--ScanStation Reminders-->
				<div *ngIf="loading == false" class="ReminderMargin">
					<div class="ReminderBorder">
						<caass-demographics-current-reminders-table [lstStationReminderAlert]="lstCurrentReminder">
						</caass-demographics-current-reminders-table>
					</div>
					<div class="ReminderBorder">
						<caass-demographics-current-block-list-table [lstBlockList]="lstBlockList"> </caass-demographics-current-block-list-table>
					</div>
				</div>

				<!--Last Printed ID Card (For Digital ID)-->
				<div *ngIf="loading == false && SchoolShowLastIDCard == true">
					<h4 style="text-align: center">Last ID Card Printed:</h4>

					<div class="IDCardFlex">
						<!--Left Col, Side 1-->
						<div class="IDCardBorder" *ngIf="IDCardSide1Enabled == true">
							<h4>Side 1</h4>

							<div *ngIf="IDCardSide1 != ''">
								<img class="IDCardSide" [src]="IDCardSide1" />
							</div>

							<div *ngIf="IDCardSide1 == ''">
								<label class="NoImage">N/A</label>
							</div>
						</div>

						<div></div>

						<!--Right Col, Side 2-->
						<div class="IDCardBorder" *ngIf="IDCardSide2Enabled == true">
							<h4>Side 2</h4>

							<div *ngIf="IDCardSide2 != ''">
								<img class="IDCardSide" [src]="IDCardSide2" />
							</div>

							<div *ngIf="IDCardSide2 == ''">
								<label class="NoImage">N/A</label>
							</div>
						</div>

						<div *ngIf="IDCardSide1Enabled == false && IDCardSide2Enabled == false">
							<label class="NoImage">N/A</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<caass-demographics-guardian-table [SelectedPerson]="SelectedPerson"> </caass-demographics-guardian-table>
